export default {
  setRetencao(state, payload) {
    state.retencao = payload
  }
}
